<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal custom">
      <div class="pull-right">
        <div class="btn-close" @click="close"></div>
      </div>
      <!--<div class="heading">
        <h1>{{ title }}</h1>
      </div>-->
      <div class="content">
        <!-- Success report -->
        <div v-if="isSuccessReport" class="success wrapper">
          <h3 class="result-title">Quelldatei:</h3>
          <h3 class="result-title">{{ json.src.file.srcFileName }}</h3>
          <div
            v-for="log in json.src.logs"
            :key="log.resultFileName"
            class="results"
          >
            <ul>
              <li v-if="!log.hasOwnProperty('error')">
                Lastgang: {{ log.resultFileName }}
              </li>
              <li v-if="isExcel">Arbeitsblatt: {{ log.srcSheetName }}</li>
              <li v-if="!log.hasOwnProperty('error')">
                Spalte: {{ log.srcColumnName }}
              </li>
              <li>Status: {{ getStatusTranslation(log.status) }}</li>
              <li v-if="log.hasOwnProperty('error')">
                Fehler: {{ log.error }}
              </li>
            </ul>
          </div>
        </div>

        <!-- Error report -->
        <div v-else class="error wrapper">
          <h3 class="result-title">Quelldatei:</h3>
          <h3 class="result-title">{{ json.src.file.srcFileName }}</h3>
          <ul>
            <li>Quelldatei: {{ json.src.file.srcFileName }}</li>
            <li>Status: Fehlerhaft</li>
            <li>Fehler: {{ json.src.logs[0].error }}</li>
          </ul>
        </div>
      </div>
      <div class="footer">
        <button class="button btn-red" @click="close">
          {{ buttonCaption }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reportViewer',
  data() {
    return {
      statusTranslation: {
        failed: 'Fehlerhaft',
        success: 'Erfolgreich',
      },
    };
  },
  props: ['title', 'json', 'buttonCaption'],
  methods: {
    close() {
      this.$emit('close');
    },
    getFrontEndNameFormat(name) {
      let regex = /^[0-9]{13}_{1}/gm;
      return name.replace(regex, '');
    },
    getStatusTranslation(status) {
      return this.statusTranslation[status];
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  computed: {
    isSuccessReport() {
      return this.json.status == 'success';
    },

    isExcel() {
      var isExcel;
      if (this.isSuccessReport) {
        isExcel = this.json.src.file.srcFileName.split('.')[1] != 'csv';
      }
      return isExcel;
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 600px;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  left: 29%;
  top: 7%;
  min-height: 410px;
  height: fit-content;
  overflow-y: hidden;
}

.heading {
  margin-top: 30px;
  margin-bottom: 10px;
  height: 100px;
  width: 100%;
  text-align: center;
  overflow-wrap: anywhere;
  overflow-y: scroll;
}

.heading::-webkit-scrollbar-track {
  background: #ffff;
  box-shadow: inset 0 0 5px rgb(255, 255, 255);
}

.heading h1 {
  margin-left: 50px;
  margin-right: 50px;
}

.content {
  padding: 20px 50px;
  background-color: rgb(249, 249, 251);
  width: 100%;
  height: 400px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #ffff;
  overflow: auto;
  min-height: 190px;
  height: fit-content;
  max-height: 325px;
}

.content::-webkit-scrollbar {
  height: 0px;
}

h1 {
  text-align: center;
  font-size: 32px;
  color: #2b2d34;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  width: 67%;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 113px;
  width: 100%;
  overflow: hidden;
}

textarea::placeholder {
  color: rgb(195, 195, 196);
}

button.default {
  color: #464d5d;
  background: #fff;
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

.input-group {
  width: 100%;
}

.imput-group > input {
  width: 70%;
}

.input-group > button {
  min-width: 0;
  width: 14%;
  height: 19px;
  text-transform: uppercase;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  background: rgb(255, 51, 102);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.125px;
  border-radius: 32px;
  padding: 16px 30px 15px;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  border-width: 0;
  border-style: none;
  margin-bottom: 40px;
  /* color: #fff; */
  /* background: #6bbc7c; */
  /* border: 1px solid #5ab36c; */
  margin-bottom: 0;
  /* border-radius: 0 3px 3px 0; */
  margin-left: 31px;
}

.btn-red {
  min-width: 0;
  width: 14%;
  text-transform: uppercase;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  background: rgb(255, 51, 102);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.125px;
  border-radius: 32px;
  padding: 16px 30px 15px;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  border-width: 0;
  border-style: none;
  margin-bottom: 40px;
  /* color: #fff; */
  /* background: #6bbc7c; */
  /* border: 1px solid #5ab36c; */
  margin-bottom: 0;
  /* border-radius: 0 3px 3px 0; */
  margin-left: 31px;
}

.pull-right {
  float: right;
  margin: 15px 15px 0px 0px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin: 0 18px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .url {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1109px;
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .mscons {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -828px -1175px;
}

.tabsLabels .system {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -137px -1178px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.message {
  font-size: 14px;
  font-family: sans-serif;
  margin-top: 7px;
  padding-left: 4px;
  font-weight: 600;
}

.message.success {
  color: #6cbd7c;
}

.message.error {
  color: rgb(255, 51, 102);
}

.footer {
  padding-top: 15px;
  padding-bottom: 30px;
  height: 60px;
}

.content ul {
  padding-right: 25px;
  padding-left: 25px;
  margin-top: 25px;
  word-break: break-all;
}

.content ul li {
  font-size: 15px;
  line-height: 25px;
  color: #7e8890;
  list-style-type: none;
}

.results {
  border-left-style: solid;
  border-left-width: thin;
  border-left-color: #eaecf1;
}

.result-title {
  text-align: center;
  font-size: 21px;
  color: #323232;
  margin-bottom: 15px;
  word-break: break-word;
}
</style>
